/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  API_URL: 'https://selfblue.cloud/', //'https://staging.selfblue.com/',
  REDIRECT_URL: 'https://selfblue.cloud/', //'https://staging.selfblue.com/',
  LOGOUT_REDIRECT: 'https://selfblue.cloud/', //'https://staging.selfblue.com/',
  CHART_REFRESH_INTERVAL: 60000,
  LANGUAGES: ['en', 'it', 'fr']
};
